import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";
import clsx from "clsx";

export enum Status {
    Draft = "Draft",
    Published = "Published",
    Archived = "Archived",
}

export interface StaffMember {
    id: number;
    name: string;
    title: string | null;
    order: number;
    twitter: string | null;
    instagram: string | null;
    twitch: string | null;
    type: number;
    image: string | null;
}

export default function Staff({ staff: { data: staff } }: { staff: { data: StaffMember[] } }) {

    const thClasses = "font-medium px-4 py-2 text-gray-500";
    const tdClasses = "border-t border-gray-200 px-4 py-2";

    return (
        <App>
            <PageTitle title="Staff" />
            <ContentWrapper>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg">Staff</h2>
                    <Link href={`/admin/staff/add`} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Staff Member</Link>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th className={clsx([thClasses, 'text-left'])}>Name</th>
                            <th className={clsx([thClasses, 'text-left'])}>Title</th>
                            <th className={clsx([thClasses, 'text-left'])}>Order</th>
                            <th className={clsx([thClasses, 'text-left'])}>Type</th>
                            <th className={clsx([thClasses, 'text-right'])}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {staff.map((member) => (
                            <tr key={member.id}>
                                <td className={tdClasses}>{member.name}</td>
                                <td className={tdClasses}>{member.title}</td>
                                <td className={tdClasses}>{member.order}</td>
                                <td className={tdClasses}>{member.type === 0 ? 'Staff' : 'Creator'}</td>
                                <td className={tdClasses}>
                                    <div className="flex justify-end">

                                        <Link href={`/admin/staff/${member.id}`} className="text-indigo-600 hover:text-indigo-800">
                                            Edit
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ContentWrapper>
        </App >
    )
}